import React from 'react';
import ReactDOM from 'react-dom/client';
import '@devils-paw/ui/tokens.css';
import '@devils-paw/ui/primitives.css';
import './styles.css';
import { App } from './app/App';

const webProtocol = window.location.protocol === 'http:' || window.location.protocol === 'https:';
const nativeRuntime = window.Capacitor?.isNativePlatform() === true;
if ('serviceWorker' in navigator && webProtocol && !nativeRuntime && (import.meta.env.PROD || import.meta.env.VITE_ENABLE_SERVICE_WORKER === 'true')) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/service-worker.js');
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
